import React from 'react';
import PropTypes from 'prop-types';
import {ThemeProvider} from '@mui/material/styles';
import {StylesProvider} from '@mui/styles';
import generateClassName from '@scripttag/helpers/generateClassName';

function MUIThemeCustomWrapper({theme, children}) {
  return (
    <ThemeProvider theme={theme}>
      <StylesProvider generateClassName={generateClassName}>{children}</StylesProvider>
    </ThemeProvider>
  );
}

MUIThemeCustomWrapper.propTypes = {
  theme: PropTypes.object,
  children: PropTypes.any
};

export default MUIThemeCustomWrapper;
